import React, { useRef } from "react";
import styles from "./BottomFindBar.module.css";

/**
 * Presentational form for entering a sequence and mismatch count.
 * Controlled by parent; no internal state.
 */
export default function FindSequenceForm({
  querySequence,
  setQuerySequence,
  maxAllowedMismatches,
  setMaxAllowedMismatches,
  onSubmit,
  isSearching,
  hasResults,
  hasPendingSearch, // if true, show "Find" even when there are results
  onDone,
}) {
  const queryRef = useRef(null);
  const mismatchesRef = useRef(null);

  const showFindButton = !hasResults || hasPendingSearch;

  const blurInputs = () => {
    // Blur both inputs (if mounted)
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
    queryRef.current?.blur();
    mismatchesRef.current?.blur();
  };

  const handleFormSubmit = (e) => {
    onSubmit(e); // parent prevents default & runs search
    blurInputs(); // immediately make inputs inactive after Enter/submit
  };

  const handleDoneClick = () => {
    onDone?.(); // parent clears query/results
    blurInputs(); // ensure inputs are inactive after Done
  };

  return (
    <form className={styles.form} onSubmit={handleFormSubmit}>
      <label className={styles.field}>
        <span className={styles.label}>Find</span>
        <input
          ref={queryRef}
          className={styles.input}
          type="text"
          value={querySequence}
          onChange={(e) =>
            setQuerySequence(
              e.target.value.replace(/[^ATGC]/gi, "").toUpperCase()
            )
          }
          placeholder="Sequence (A/T/G/C)"
          required
          inputMode="latin"
          autoCapitalize="characters"
        />
      </label>

      <label className={styles.field}>
        <span className={styles.label}>Max mismatches</span>
        <input
          ref={mismatchesRef}
          className={styles.inputNum}
          type="number"
          min={0}
          value={maxAllowedMismatches}
          onChange={(e) => setMaxAllowedMismatches(Number(e.target.value))}
        />
      </label>

      {showFindButton ? (
        <button
          type="submit"
          className={`${styles.btn} ${styles.btnPrimary}`}
          disabled={isSearching || !querySequence}
        >
          {isSearching ? "Searching…" : "Find"}
        </button>
      ) : (
        <button
          type="button"
          className={`${styles.btn} ${styles.btnSecondary}`}
          onClick={handleDoneClick}
          title="Clear results and query"
        >
          Done
        </button>
      )}
    </form>
  );
}
